import { render, staticRenderFns } from "./SocialMediaLanding.vue?vue&type=template&id=4d7ebe18&scoped=true"
import script from "./SocialMediaLanding.vue?vue&type=script&lang=js"
export * from "./SocialMediaLanding.vue?vue&type=script&lang=js"
import style0 from "./SocialMediaLanding.vue?vue&type=style&index=0&id=4d7ebe18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d7ebe18",
  null
  
)

export default component.exports